import { Fragment, ReactElement } from 'react'
import LoadCaseAbbreviation from '../../CheckInformation/LoadCaseAbbreviation'

const LoadCaseCombinationFormula = ({ lcc }: { lcc?: LoadCaseCombination }): ReactElement => {
  if (!lcc?.data?.length) return <>-</>

  return (
    <>
      {lcc.data.map(([v1, v2, loadCase], i) => (
        <Fragment key={i}>
          {v1}*{v2}*
          <LoadCaseAbbreviation combination={loadCase} />
          {i !== lcc.data.length - 1 && ' + '}
        </Fragment>
      ))}
    </>
  )
}

export default LoadCaseCombinationFormula
